import alt from "../alt";

class FilmActions {
  constructor() {
    this.generateActions("updateFilms", "fetchAll", "fetchOne", "fetchFailed");
  }

  updateFilm(id, film) {
    return { id, film };
  }
}

export default alt.createActions(FilmActions);



// WEBPACK FOOTER //
// ./src/app/actions/FilmActions.js